module.exports = __webpack_public_path__ + "static/media/success.21206300.svg";